import React, { useState, useContext, useEffect } from "react";
import ReactDOM from "react-dom";

import axios from "axios";
import apiEndpointList from "../../../../config/core_banking/endpoint";
import { APIConfig } from "../../../../services/apiConfiguration";

import { Loader } from "rsuite";
import FailureDialog from "../../../Shared/FailureDialog/FailureDialog";
import VirtualAccountsSuccessDialog from "../../../VirtualAccountsSuccessDialog/VirtualAccountsSuccessDialog";
import unMountPreviousComponent from "../../../../utilities/unMountPreviousComponent";
import VirtualAccountContext, {
  VirtualAccountContextContextProvider,
} from "../../VirtualAccountContext";
import Tooltip from "../../../Shared/Tooltip/Tooltip";

// posthog imports
import { capturePosthogEvent } from "../../../../utilities/posthogUtils";

// styles import
import "./CreateVirtualAccountForm.scss";

function CreateVirtualAccountForm({ data, tableEditRow, refresh }) {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  // ^ context
  const { refreshTable } = useContext(VirtualAccountContextContextProvider);

  // Bank Provider Dropdown
  const [selectedOption, setSelectedOption] = React.useState("");
  const [selectedBankCode, setSelectedBankCode] = useState(null);
  const [providerApiData, setProviderApiData] = React.useState("");

  // Master Alias Dropdown
  const [masterAliasSelectedOption, setMasterAliasSelectedOption] =
    useState("");
  const [masterAliasProvider, setMasterAliasProvider] = useState("");
  const [disableMasterAliasDropDown, setDisableMasterAliasDropDown] =
    useState(true);
  const [TaskMenuItem, setTaskMenuItem] = React.useState("Select Master Alias");

  // & Bank Provider Dropdown Details
  const cvaProvider = () => {
    setMasterAliasSelectedOption("");
    setMasterAliasProvider("");
    setTaskMenuItem("Select Master Alias");
    setDisableMasterAliasDropDown(true);

    APIConfig.API_Client.post(
      apiEndpointList.PROVIDER_ACCOUNTS.baseUrl +
      apiEndpointList.PROVIDER_ACCOUNTS.endpoint,
      {},
      {
        cancelToken: source.token,
      }
    )
      .then((response) => {
        setProviderApiData(response.data);
        setMasterAliasSelectedOption("");
        setMasterAliasProvider("");
        setTaskMenuItem("Select Master Alias");
        setDisableMasterAliasDropDown(true);
      })
      .catch((error) => { });
  };

  // & Master Alias Dropdown Details
  const masterAliasProviderData = () => {
    setMasterAliasSelectedOption("");
    setMasterAliasProvider("");
    setTaskMenuItem("Select Master Alias");
    setDisableMasterAliasDropDown(true);

    APIConfig.API_Client.post(
      apiEndpointList.MASTER_ALIAS_PROVIDER_ACCOUNTS.baseUrl +
      apiEndpointList.MASTER_ALIAS_PROVIDER_ACCOUNTS.endpoint,
      {
        provider_id: selectedBankCode,
      },
      {
        cancelToken: source.token,
      }
    )
      .then((response) => {
        setMasterAliasProvider(response.data);

        if (response.data.length !== 0) {
          setDisableMasterAliasDropDown(false);
        }
      })
      .catch((error) => {
        setDisableMasterAliasDropDown(true);
      });
  };

  const [verifyKyc, setVerifyKyc] = React.useState({
    kycVerifyToggle: false,
    decentroKycToggle: false,
  });

  //regex for validation
  let addressRegex = /^[^*|":<>[\]{}`\\()';@&$]+$/;
  let mobileRegex = /^[6-9]\d{9}$/;

  //states
  const [customerDetails, setCustomerDetails] = React.useState({
    nameInput: "",
    panInput: "",
    emailInput: "",
    mobileInput: "",
    addressInput: "",
    customerIdInput: "",
    minimumBalanceInput: "",
    transactionLimitInput: "",
  });

  let [inputData, setInputData] = React.useState({
    customerName: "",
    customerPan: "",
    customerEmail: "",
    mobileNumber: "",
    customerAddress: "",
    customerId: "",
    minimumBalance: "",
    transactionLimit: "",
  });

  const [inputValidation, setInputValidation] = React.useState({
    nameError: "",
    panError: "",
    emailError: "",
    mobileNoError: "",
    addressError: "",
    customerIdError: "",
    minimumBalanceError: "",
    transactionLimitError: "",
  });

  const [inputValidationBtn, setInputValidationBtn] = React.useState({
    nameError: "",
    panError: "",
    emailError: "",
    mobileNoError: "",
    addressError: "",
    customerIdError: "",
    minimumBalanceError: "",
    transactionLimitError: "",
  });
  let customerDetail;

  const handleBlur = (event) => {
    let { name, value } = event.target;
    let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    let customerIdRegex = /^[a-zA-Z0-9]*$/;
    let nameRegex = /^[a-zA-Z]+(\s[a-zA-Z]+)*$/;

    if (name == "customerEmail") {
      if (!value.match(emailRegex)) {
        setInputData({ ...inputData, [name]: "" });
        setInputValidation({
          ...inputValidation,
          emailError: "Invalid format",
        });
      } else {
        setInputValidation({
          ...inputValidation,
          emailError: "",
        });
        setInputValidationBtn({
          ...inputValidationBtn,
          emailError: "",
        });
      }
    }
    if (name == "mobileNumber") {
      if (!value.match(mobileRegex)) {
        setInputData({ ...inputData, [name]: "" });
        setInputValidation({
          ...inputValidation,
          mobileNoError: "Invalid format",
        });
      } else {
        setInputValidation({
          ...inputValidation,
          mobileNoError: "",
        });
        setInputValidationBtn({
          ...inputValidationBtn,
          mobileNoError: "",
        });
      }
    }
    if (name == "customerPan") {
      if (!value.match(panRegex)) {
        setInputData({ ...inputData, [name]: "" });
        setInputValidation({ ...inputValidation, panError: "Invalid format" });
      } else {
        setInputValidationBtn({ ...inputValidationBtn, panError: "" });
        setInputValidation({ ...inputValidation, panError: "" });
      }
    }
    if (name === "transactionLimit") {
      if (event.target.value >= "1") {
        if (event.target.validity.patternMismatch) {
          setInputData({ ...inputData, [name]: "" });
          setInputValidation({
            ...inputValidation,
            transactionLimitError: "Invalid format",
          });
        }
      } else {
        setInputData({ ...inputData, [name]: "" });
        setInputValidation({
          ...inputValidation,
          transactionLimitError: "Transaction Limit must be at least 1",
        });
        setInputValidationBtn({
          ...inputValidationBtn,
          transactionLimitError: "Invalid",
        });
      }
    }
    if (name === "minimumBalance") {
      if (event.target.value >= "1") {
        if (event.target.validity.patternMismatch) {
          setInputData({ ...inputData, [name]: "" });
          setInputValidation({
            ...inputValidation,
            minimumBalanceError: "Invalid format",
          });
        }
      } else {
        setInputData({ ...inputData, [name]: "" });
        setInputValidation({
          ...inputValidation,
          minimumBalanceError: "Minimum Balance must be at least 1",
        });
      }
    }
    if (name === "customerId") {
      if (!value.match(customerIdRegex)) {
        // setInputData({ ...inputData, [name]: "" });
        setInputValidation({
          ...inputValidation,
          customerIdError: "Invalid format",
        });
      }
    }
    if (name === "customerName") {
      if (!value.match(nameRegex)) {
        setInputData({ ...inputData, [name]: "" });
        setInputValidation({ ...inputValidation, nameError: "Invalid format" });
      }
    }
    if (name === "customerAddress") {
      if (!value.match(addressRegex)) {
        setInputData({ ...inputData, [name]: "" });
        setInputValidation({
          ...inputValidation,
          addressError: "Invalid format",
        });
      }
    }
  };

  const handleContactDetails = (e) => {
    let { name, value } = e.target;

    if (name === "customerName") {
      setCustomerDetails({ ...customerDetails, nameInput: value });
      let nameRegex = /^[a-zA-Z ]+$/;

      if (value.match(nameRegex)) {
        setInputData({ ...inputData, [name]: value.trim() });
        setInputValidation({ ...inputValidation, nameError: "" });
      } else {
        setInputData({ ...inputData, [name]: "" });
        setInputValidation({ ...inputValidation, nameError: "Invalid Format" });
        setInputValidationBtn({
          ...inputValidationBtn,
          nameError: "Invalid format",
        });
      }
    }

    if (name === "customerPan") {
      setCustomerDetails({ ...customerDetails, panInput: value });
      let panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

      if (value.match(panRegex)) {
        setInputData({ ...inputData, [name]: value.toUpperCase() });
        setInputValidation({ ...inputValidation, panError: "" });
        setInputValidationBtn({ ...inputValidationBtn, panError: "" });
      } else {
        setInputData({ ...inputData, [name]: "" });
        setInputValidation({ ...inputValidation, panError: "Invalid Format" });
        setInputValidationBtn({
          ...inputValidationBtn,
          panError: "Invalid format",
        });
      }
    }

    if (name === "customerEmail") {
      setCustomerDetails({ ...customerDetails, emailInput: value });
      let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (value.match(emailRegex)) {
        setInputData({ ...inputData, [name]: value });
        setInputValidation({ ...inputValidation, emailError: "" });
      } else {
        setInputData({ ...inputData, [name]: "" });
        setInputValidationBtn({
          ...inputValidationBtn,
          emailError: "Invalid format",
        });
      }
    }

    if (name === "mobileNumber") {
      setCustomerDetails({ ...customerDetails, mobileInput: value });

      if (value.match(mobileRegex)) {
        setInputData({ ...inputData, [name]: value });
        setInputValidation({ ...inputValidation, mobileNoError: "" });
      } else {
        setInputData({ ...inputData, [name]: "" });
        setInputValidationBtn({
          ...inputValidationBtn,
          mobileNoError: "Invalid format",
        });
      }
    }

    if (name === "customerAddress") {
      setCustomerDetails({ ...customerDetails, addressInput: value });

      if (value.match(addressRegex)) {
        setInputData({ ...inputData, [name]: value.trim() });
        setInputValidation({ ...inputValidation, addressError: "" });
      } else {
        setInputData({ ...inputData, [name]: "" });
        setInputValidationBtn({
          ...inputValidationBtn,
          addressError: "Invalid format",
        });
      }
    }

    if (name === "customerId") {
      setCustomerDetails({ ...customerDetails, customerIdInput: value });
      setInputData({ ...inputData, [name]: value.trim() });
      let customerIdRegex = /^[a-zA-Z0-9]*$/;

      if (value.match(customerIdRegex)) {
        // setInputData({ ...inputData, [name]: value.trim() });
        setInputValidation({ ...inputValidation, customerIdError: "" });
      } else {
        // setInputData({ ...inputData, [name]: "" });
        setInputValidationBtn({
          ...inputValidationBtn,
          customerIdError: "Invalid format",
        });
      }
    }

    if (name === "minimumBalance") {
      let minBalRegex = /^[1-9][0-9]*$/;

      if (value.match(minBalRegex) || value === "") {
        setCustomerDetails({ ...customerDetails, minimumBalanceInput: value });
        setInputData({ ...inputData, [name]: value });
        setInputValidation({ ...inputValidation, minimumBalanceError: "" });
      } else {
        setInputData({ ...inputData, [name]: "" });
        setInputValidationBtn({
          ...inputValidationBtn,
          minimumBalanceError: "Invalid format",
        });
      }
    }

    if (name === "transactionLimit") {
      setCustomerDetails({ ...customerDetails, transactionLimitInput: value });
      let limitBalRegex = /^[0-9]+$/;
      if (value >= "1") {
        if (value.match(limitBalRegex)) {
          setInputData({ ...inputData, [name]: value });
          setInputValidation({ ...inputValidation, transactionLimitError: "" });
        } else {
          setInputData({ ...inputData, [name]: "" });
          setInputValidation({
            ...inputValidation,
            transactionLimitError: "Invalid",
          });
          setInputValidationBtn({
            ...inputValidationBtn,
            transactionLimitError: "Invalid format",
          });
        }
      } else {
        setInputData({ ...inputData, [name]: "" });
        setInputValidation({
          ...inputValidation,
          transactionLimitError: "Invalid",
        });
        setInputValidationBtn({
          ...inputValidationBtn,
          transactionLimitError: "Transaction Limit must be at least 1",
        });
      }
    }
  };

  const getPayloadData = (data) => {
    customerDetail = data;
    createVirtualAccountApi();
  };

  // & On submit CVA creation
  const createVirtualAccountApi = () => {
    let payloadData = {
      bank_codes: customerDetail.bankProvider,
      name: customerDetail.customerName,
      pan: customerDetail.customerPan,
      email: customerDetail.customerEmail,
      mobile: customerDetail.mobileNumber,
      address: customerDetail.customerAddress,
      kyc_verified: customerDetail.kycVerifyToggle,
      kyc_check_decentro: customerDetail.decentroKycToggle,
      minimum_balance: +customerDetail.minimumBalance,
      transaction_limit: +customerDetail.transactionLimit,
      customer_id: customerDetail.customerId,
      master_account_alias: masterAliasSelectedOption,
    };

    ReactDOM.render(
      <Loader size="xs" />,
      document.getElementById("user-config-loader")
    );

    APIConfig.API_Client.post(
      apiEndpointList.CREATE_VIRTUAL_ACCOUNT.baseUrl +
      apiEndpointList.CREATE_VIRTUAL_ACCOUNT.endpoint,
      payloadData,
      { cancelToken: source.token }
    )
      .then((response) => {
        ReactDOM.unmountComponentAtNode(
          document.getElementById("user-config-loader")
        );

        unMountPreviousComponent("virtual-accounts-components");

        ReactDOM.render(
          <VirtualAccountContext>
            <VirtualAccountsSuccessDialog
              data={response.data.data}
              refresh={refresh}
            />
          </VirtualAccountContext>,
          document.getElementById("virtual-accounts-components")
        );
      })
      .catch((error) => {
        ReactDOM.unmountComponentAtNode(
          document.getElementById("user-config-loader")
        );

        unMountPreviousComponent("virtual-accounts-components");

        try {
          ReactDOM.render(
            <FailureDialog
              header={"Create Virtual Accounts"}
              msg={error.response.data.message}
            />,
            document.getElementById("failure-popup")
          );
        } catch (error) {
          ReactDOM.render(
            <FailureDialog
              header={"Create Virtual Accounts"}
              msg={"Something went wrong please try again later"}
            />,
            document.getElementById("failure-popup")
          );
        }
      });
  };

  const customerData = () => {
    let data = {
      ...verifyKyc,
      ...inputData,
      bankProvider: [selectedOption],
      setRefresh: true,
    };
    getPayloadData(data);
  };
  const kycToggle = (e) => {
    const { name, checked } = e.target;
    setVerifyKyc({
      ...verifyKyc,
      [name]: +checked,
    });
  };

  let [submitBtnValidation, setSubmitBtnValidation] = useState(true);

  //To Check the button validation , should be available only when the required fields are filled

  useEffect(() => {
    if (
      customerDetails.nameInput !== "" &&
      inputValidation.nameError === "" &&
      customerDetails.emailInput !== "" &&
      inputValidation.emailError === "" &&
      customerDetails.mobileInput !== "" &&
      inputValidation.mobileNoError === "" &&
      inputValidation.transactionLimitError === "" &&
      customerDetails.transactionLimitInput !== "" &&
      customerDetails.panInput !== "" &&
      inputValidation.panError === "" &&
      customerDetails.minimumBalanceInput !== "" &&
      inputValidation.minimumBalanceError === "" &&
      selectedOption !== "" &&
      masterAliasSelectedOption.length !== 0
    ) {
      setSubmitBtnValidation(false);
    } else {
      setSubmitBtnValidation(true);
    }
  }, [customerDetails, selectedOption, masterAliasSelectedOption]);

  useEffect(() => {
    cvaProvider();
  }, []);

  useEffect(() => {
    masterAliasProviderData();
  }, [selectedBankCode, selectedOption]);

  useEffect(() => { }, [refreshTable]);

  return (
    <div className="cva-main-card-container">
      {/* The company and user type search */}
      <div className="input-user-form-fields">
        <div className="company-search">
          {/* Bank Provider */}
          <div className="company">
            <div className="user-search-input-label-not-required">
              Bank Provider
              <Tooltip
                requiredField={true}
                text="	
                Bank provider on which Virtual Account has to be created"
              >
                <button className="info-icon">
                  <img src="/images/info-icon.svg" alt="information icon" />
                </button>
              </Tooltip>
            </div>
            <VirtualAccountsTaskMenu
              setSelectedProvider={setSelectedOption}
              setSelectedBankCode={setSelectedBankCode}
              providerApiData={providerApiData}
              editable={true}
            />
          </div>

          {/* Master Alias */}
          <div className="user-name-main">
            <div className="label name">
              <div className="label-tag-not-required">
                Master Alias
                <Tooltip
                  requiredField={true}
                  text="	
                Master alias for the selected Bank Provider"
                >
                  <button className="info-icon">
                    <img src="/images/info-icon.svg" alt="information icon" />
                  </button>
                </Tooltip>
              </div>
              <div
                className={`user-input ${Boolean(inputValidation.masterAliasError) && "error-border"
                  }`}
              >
                <MasterAliasAccountMenu
                  setSelectedProvider={setMasterAliasSelectedOption}
                  providerApiData={masterAliasProvider}
                  disabled={disableMasterAliasDropDown}
                  TaskMenuItem={TaskMenuItem}
                  setTaskMenuItem={setTaskMenuItem}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main form */}
      <div className="input-user-form-fields">
        {/* Customer Name */}
        <div className="email-name-main">
          <div className="label email">
            <div className="label-tag">
              Customer <br /> Name{" "}
            </div>
            <div
              className={`user-input ${Boolean(inputValidation.nameError) && "error-border"
                }`}
            >
              <input
                className={`user-input-field`}
                type="text"
                id="name"
                name="customerName"
                placeholder="Enter customer's name"
                value={customerDetails.nameInput}
                onChange={handleContactDetails}
                onBlur={handleBlur}
                autoComplete="false"
              />
              <img
                className={`in_not ${Boolean(inputValidation.nameError) ? "show" : "hide"
                  }`}
                src="/images/invalid-input.svg"
                alt="invalid-icon"
              />
            </div>
          </div>
        </div>

        {/* Customer ID */}
        <div className="user-name-main">
          <div className="label name">
            <div className="label-tag-not-required">
              Customer ID
              <Tooltip
                requiredField={true}
                text="	
                A unique ID for each customer"
              >
                <button className="info-icon">
                  <img src="/images/info-icon.svg" alt="information icon" />
                </button>
              </Tooltip>
            </div>
            <div
              className={`user-input ${Boolean(inputValidation.customerIdError) && "error-border"
                }`}
            >
              <input
                className={`user-input-field`}
                id="ifsc-label"
                name="customerId"
                placeholder="Enter customer's ID"
                // disabled={tableEditRow}
                value={customerDetails.customerIdInput}
                onChange={handleContactDetails}
                onBlur={handleBlur}
                autoComplete="new-password"
              />
              <img
                className={`in_not ${Boolean(inputValidation.customerIdError) ? "show" : "hide"
                  }`}
                src="/images/invalid-input.svg"
                alt="invalid-icon"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="input-user-form-fields">
        {/* Email */}
        <div className="user-name-main">
          <div className="label name">
            <div className="label-tag" style={{ display: "inline" }}>
              Email
            </div>
            <div
              className={`user-input ${Boolean(inputValidation.emailError) && "error-border"
                }`}
            >
              <input
                className={`user-input-field`}
                id="sender-label"
                name="customerEmail"
                variant="outlined"
                // disabled={tableEditRow}
                placeholder="Enter customer's email"
                value={customerDetails.emailInput}
                onChange={handleContactDetails}
                onBlur={handleBlur}
                autoComplete="false"
              />
              <img
                className={`in_not ${Boolean(inputValidation.emailError) ? "show" : "hide"
                  }`}
                src="/images/invalid-input.svg"
                alt="invalid-icon"
              />
            </div>
          </div>
        </div>

        {/* PAN */}
        <div className="user-name-main">
          <div className="label name">
            <div className="label-tag-not-required">
              PAN
              <Tooltip
                requiredField={true}
                text="	
                A valid PAN number of the virtual account holder. Required for sub-merchant onboarding"
              >
                <button className="info-icon">
                  <img src="/images/info-icon.svg" alt="information icon" />
                </button>
              </Tooltip>
            </div>
            <div
              className={`user-input ${Boolean(inputValidation.panError) && "error-border"
                }`}
            >
              <input
                className={`user-input-field`}
                id="email-label"
                name="customerPan"
                placeholder="Enter customer's PAN"
                value={customerDetails.panInput}
                onChange={handleContactDetails}
                onBlur={handleBlur}
                autoComplete="new-password"
              />
              <img
                className={`in_not ${Boolean(inputValidation.panError) ? "show" : "hide"
                  }`}
                src="/images/invalid-input.svg"
                alt="invalid-icon"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="input-user-form-fields">
        {/* Minimum Balance */}
        <div className="user-name-main">
          <div className="label name">
            <div className="label-tag-not-required">
              Minimum
              <br /> Balance{" "}
              <Tooltip
                requiredField={true}
                text="
                  The minimum amount that has to be maintained in the virtual account"
              >
                <button className="info-icon">
                  <img src="/images/info-icon.svg" alt="information icon" />
                </button>
              </Tooltip>
            </div>
            <div
              className={`user-input ${Boolean(inputValidation.minimumBalanceError) && "error-border"
                }`}
            >
              <input
                className={`user-input-field`}
                id="email-label"
                name="minimumBalance"
                placeholder="Set minimum balance"
                value={customerDetails?.minimumBalanceInput}
                onChange={handleContactDetails}
                onBlur={handleBlur}
                autoComplete="new-password"
              // type="number"
              />
              <img
                className={`in_not ${Boolean(inputValidation.minimumBalanceError) ? "show" : "hide"
                  }`}
                src="/images/invalid-input.svg"
                alt="invalid-icon"
              />
            </div>
          </div>
        </div>

        {/* Transaction Limit */}
        <div className={`user-name-main`}>
          <div className="label name">
            <div className="label-tag-not-required">
              Transaction <br /> Limit
              <Tooltip
                requiredField={true}
                text="
                Maximum transaction amount for this virtual account. Ex - 10000"
              >
                <button className="info-icon">
                  <img src="/images/info-icon.svg" alt="information icon" />
                </button>
              </Tooltip>
            </div>
            <div
              className={`user-input ${Boolean(inputValidation.transactionLimitError) && "error-border"
                }`}
            >
              <input
                className={`user-input-field`}
                id="account-lable"
                // disabled={tableEditRow}
                name="transactionLimit"
                placeholder="Set transaction limit"
                value={customerDetails.transactionLimitInput}
                onChange={handleContactDetails}
                onBlur={handleBlur}
                autoComplete="new-password"
              />
              <img
                className={`in_not ${Boolean(inputValidation.transactionLimitError)
                    ? "show"
                    : "hide"
                  }`}
                src="/images/invalid-input.svg"
                alt="invalid-icon"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="input-user-form-fields">
        {/* Customer Mobile */}
        <div className="email-name-main">
          <div className="label email">
            <div className="label-tag">
              {" "}
              Customer <br /> Mobile No{" "}
            </div>
            <div
              className={`user-input ${Boolean(inputValidation.mobileNoError) && "error-border"
                }`}
            >
              <input
                className={`user-input-field`}
                id="mobile-label"
                name="mobileNumber"
                maxLength={10}
                placeholder="Enter Customers Mobile No"
                value={customerDetails.mobileInput}
                onChange={handleContactDetails}
                onBlur={handleBlur}
                type="tel"
                autoComplete="new-phone"
              />
              <img
                className={`in_not ${Boolean(inputValidation.mobileNoError) ? "show" : "hide"
                  }`}
                src="/images/invalid-input.svg"
                alt="invalid-icon"
              />
            </div>
          </div>
        </div>

        {/* Address */}
        <div className="user-name-main">
          <div className="label name">
            <div className="label-tag-not-required">
              Address
              <Tooltip
                requiredField={true}
                text="	
                Address of the Virtual Account holder"
              >
                <button className="info-icon">
                  <img src="/images/info-icon.svg" alt="information icon" />
                </button>
              </Tooltip>
            </div>
            <div
              className={`user-input ${Boolean(inputValidation.addressError) && "error-border"
                }`}
            >
              <input
                className={`user-input-field`}
                id="upi-label"
                name="customerAddress"
                //  disabled={tableEditRow}
                placeholder="Enter customer's address"
                value={customerDetails.addressInput}
                onChange={handleContactDetails}
                onBlur={handleBlur}
                autoComplete="new-password"
              />
              <img
                className={`in_not ${Boolean(inputValidation.addressError) ? "show" : "hide"
                  }`}
                src="/images/invalid-input.svg"
                alt="invalid-icon"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Toggle Section */}
      <div className="input-user-form-fields">
        <div className="kyc-toggle-container">
          <span className="kyc-toggle-container-label">
            KYC Verified
            <Tooltip
              requiredField={false}
              text="True, if the KYC of the merchant has been verified by you"
            >
              <button className="info-icon">
                <img src="/images/info-icon.svg" alt="information icon" />
              </button>
            </Tooltip>
          </span>
          <div className="toggle-section">
            <span
              className={!verifyKyc.kycVerifyToggle ? "text-toggle" : undefined}
            >
              No
            </span>
            <input
              id="switch-one"
              className="checkbox"
              name="kycVerifyToggle"
              value={verifyKyc.kycVerifyToggle}
              checked={verifyKyc.kycVerifyToggle}
              onChange={kycToggle}
              type="checkbox"
            />
            <label htmlFor="switch-one" className="toggle"></label>
            <span
              className={verifyKyc.kycVerifyToggle ? "text-toggle" : undefined}
            >
              Yes
            </span>
          </div>
        </div>

        {/* <div className="kyc-toggle-divider "></div> */}
        <div className="kyc-toggle-container">
          <span className="kyc-toggle-container-label">
            Decentro KYC
            <Tooltip
              requiredField={false}
              text="True, if the KYC of the merchant is verified by the Decentro team"
            >
              <button className="info-icon">
                <img src="/images/info-icon.svg" alt="information icon" />
              </button>
            </Tooltip>
          </span>
          <div className="toggle-section">
            <span
              className={
                !verifyKyc.decentroKycToggle ? "text-toggle" : undefined
              }
            >
              No
            </span>
            <input
              id="switch-two"
              className="checkbox"
              name="decentroKycToggle"
              value={verifyKyc.decentroKycToggle}
              checked={verifyKyc.decentroKycToggle}
              onChange={kycToggle}
              type="checkbox"
            />
            <label htmlFor="switch-two" className="toggle"></label>
            <span
              className={
                verifyKyc.decentroKycToggle ? "text-toggle" : undefined
              }
            >
              Yes
            </span>
          </div>
        </div>
      </div>
      <div className="input-user-form-fields">
        <div className="button-container">
          <button
            onClick={() => {
              customerData();
              if (
                process.env.REACT_APP_ENV_NAME === "staging" ||
                process.env.REACT_APP_ENV_NAME === "production"
              ) {
                capturePosthogEvent(
                  window.location.origin,
                  window.location.pathname,
                  "submit"
                );
              }
            }}
            type="button"
            disabled={submitBtnValidation}
            className={`submit-btn-va ${submitBtnValidation === true ? "" : "active-va"
              }`}
          >
            Submit
            <span id="user-config-loader" style={{ display: "flex" }}></span>
          </button>
        </div>
      </div>
    </div>
  );
}

// Bank Provider Dropdown
function VirtualAccountsTaskMenu(props) {
  const [TaskMenuItem, setTaskMenuItem] = React.useState("Select Bank");
  const [MenuActive, setMenuActive] = React.useState(false);

  const handleClickOutside = (event) => {
    const menuContainer = document.querySelector(".provider-dropdown-cv");
    if (menuContainer && !menuContainer.contains(event.target)) {
      setMenuActive(false);
      document
        .querySelector(".provider-show-cv")
        .classList.remove("show-border-cv");
    }
  };

  React.useEffect(() => {
    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleToggleMenu = () => {
    setMenuActive(!MenuActive);
    document
      .querySelector(".provider-bank-option-cv")
      .classList.toggle("active-cv");
    document
      .querySelector(".provider-show-cv")
      .classList.toggle("show-border-cv");
  };

  return (
    <div className="provider-dropdown-cv">
      <span
        className="provider-show-cv"
        onClick={(e) => {
          handleToggleMenu();
        }}
      >
        {TaskMenuItem === "Select Bank" ? (
          <span className="placeholder-text-cv">{TaskMenuItem}</span>
        ) : (
          <span className="provider-text-cv">{TaskMenuItem}</span>
        )}
        {/* <KeyboardArrowDownSharp /> */}
        <img
          style={{
            transform: MenuActive ? "rotate(180deg)" : "rotate(0deg)",
          }}
          src="/images/arrow-down.svg"
          alt="dropdown-arrow"
        />
      </span>
      <div
        className={`provider-bank-option-cv ${MenuActive ? "active-cv" : ""}`}
      >
        <div className="provider-options-cv">
          {props.providerApiData ? (
            props.providerApiData
              .filter((data) => data.bank_name !== TaskMenuItem)
              .map((data, index) => (
                <div key={index}>
                  <div
                    onClick={() => {
                      setMenuActive(!MenuActive);
                      document
                        .querySelector(".provider-bank-option-cv")
                        .classList.remove("active-cv");
                      document
                        .querySelector(".provider-show-cv")
                        .classList.remove("show-border-cv");
                      setTaskMenuItem(data.bank_name);
                      props.setSelectedProvider(data.bank_code);
                      props.setSelectedBankCode(data.bank_id);
                    }}
                    className="option-cv"
                  >
                    {data.bank_name}
                  </div>
                </div>
              ))
          ) : (
            <span style={{ padding: "10px 0", paddingLeft: "10px" }}>
              Loading...
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

// Master Alias Dropdown
function MasterAliasAccountMenu(props) {
  // const [props.TaskMenuItem, setTaskMenuItem] = React.useState("Select Master Alias");
  const [MenuActive, setMenuActive] = React.useState(false);

  const handleClickOutside = (event) => {
    const menuContainer = document.querySelector(".master-alias-dropdown-ma");
    if (menuContainer && !menuContainer.contains(event.target)) {
      setMenuActive(false);
      document
        .querySelector(".master-alias-show-ma")
        .classList.remove("show-border-ma");
    }
  };

  React.useEffect(() => {
    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleToggleMenu = () => {
    setMenuActive(!MenuActive);
    document
      .querySelector(".master-alias-bank-option-ma")
      .classList.toggle("active-ma");
    document
      .querySelector(".master-alias-show-ma")
      .classList.toggle("show-border-ma");
  };

  return (
    <div className={`master-alias-dropdown-ma`}>
      <span
        className={`master-alias-show-ma ${props.disabled && "master-alias-disabled"
          }`}
        onClick={(e) => {
          handleToggleMenu();
        }}
      >
        {props.TaskMenuItem === "Select Master Alias" ? (
          <span className="placeholder-text-ma">{props.TaskMenuItem}</span>
        ) : (
          <span className="master-alias-text-ma">{props.TaskMenuItem}</span>
        )}
        {/* <KeyboardArrowDownSharp /> */}
        {props.disabled ? (
          ""
        ) : (
          <img
            style={{
              transform: MenuActive ? "rotate(180deg)" : "rotate(0deg)",
            }}
            src="/images/arrow-down.svg"
            alt="dropdown-arrow"
          />
        )}
      </span>
      <div
        className={`master-alias-bank-option-ma ${MenuActive ? "active-ma" : ""
          }`}
      >
        <div className="master-alias-options-ma">
          {props.providerApiData ? (
            props.providerApiData
              .filter(
                (data) => data.master_account_alias !== props.TaskMenuItem
              )
              .map((data, index) => (
                <div key={index}>
                  <div
                    onClick={() => {
                      setMenuActive(!MenuActive);
                      document
                        .querySelector(".master-alias-bank-option-ma")
                        .classList.remove("active-ma");
                      document
                        .querySelector(".master-alias-show-ma")
                        .classList.remove("show-border-ma");
                      props.setTaskMenuItem(data.master_account_alias);
                      props.setSelectedProvider(data.master_account_alias);
                    }}
                    className="option-ma"
                  >
                    {data.master_account_alias}
                  </div>
                </div>
              ))
          ) : (
            <span style={{ padding: "10px 0", paddingLeft: "10px" }}>
              Loading...
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default CreateVirtualAccountForm;